import Grid from '@mui/material/Unstable_Grid2';
import { DeloitteInfo } from 'TaxAnalyticsUI/Deloitte';
import { MethodItem } from 'TaxAnalyticsUI/methodItem';
import { MethodoTraitement, MethodoContact, MethodoLivrable, MethodoDocuments } from 'TaxAnalyticsUI/icons';
import { tag } from 'TaxAnalyticsHelpers/ATInternet';
import { useLocation } from 'react-router';
import { useEffect } from 'react';

const methodo = {
    title: "Notre méthodologie",
    text: "Un espace dédié pour suivre l’ensemble des analyses réalisées sur Tax Analytics. ",
    methodItems: [
        {
            title: "Un accompagnement personnalisé ",
            text: "Réalisé par nos experts, assistant de nombreuses entreprises lors de contrôles fiscaux ou projets digitaux",
            icon: MethodoContact
        },
        {
            title: "Un partage sécurisé des données",
            text: "Hébergées sur nos serveurs situés en France, nous sommes certifiés ISO-27001",
            icon: MethodoDocuments
        },
        {
            title: "Une analyse complète",
            text: "À partir de vos données brutes ou retravaillées permettant de mettre en évidence les éventuels risques ou opportunités.",
            icon: MethodoTraitement
        },
        {
            title: "Un rapport de synthèse",
            text: "Signé et sécurisé listant les analyses réalisées et les conclusions associées.",
            icon: MethodoLivrable
        }
    ]
}

export function Methodo() {
    //ADD Dashboards
    const location = useLocation();
    useEffect(() => {
        tag.sendPage({
            name: "Methodo"
        });
    }, [location.pathname]);
    return (
        <Grid container spacing={2}>
            <Grid container component="section" id="landing">
                <Grid xs={12}>
                    <DeloitteInfo title={methodo.title} text={methodo.text} />
                </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="center" xs={12} spacing={2}>

                {methodo.methodItems.map((item, index) =>
                    <Grid key={index} >
                        <MethodItem {...item} index={index + 1} isLast={index + 1 === methodo.methodItems.length}></MethodItem>
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
}